import { graphql } from "gatsby"

import React from "react"
import Helmet from "react-helmet"
import { Layout } from "../components/layout"

export default function template({ data }) {
    const { markdownRemark } = data
    const { frontmatter, html } = markdownRemark
    const { slug, title, date } = frontmatter
    const metadata = []
    if (date) {
        metadata.push(<meta property="article:published_time" content={date} />)
    }
    return (
        <>
            <Helmet htmlAttributes={{
                lang: "ja",
                prefix: "og: http://ogp.me/ns# article: http://ogp.me/ns/article#",
            }}>
                <title>{title}</title>
                {metadata}
            </Helmet>
            <Layout slug={slug}>
                <div
                    className="blog-post-content"
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </Layout>
        </>
    )
}

export const pageQuery = graphql`
    query contentBySlug($slug: String!) {
        markdownRemark(frontmatter: { slug: { eq: $slug } }) {
            html
            frontmatter {
                date(formatString: "YYYY-MM-DD")
                slug
                title
            }
        }
    }
`
